import { FormProvider as ReactHookFormProvider } from 'react-hook-form';

import type { UseEditPersonaFormReturn } from '../hooks/useEditPersonaForm/useEditPersonaForm';
import { FormContext } from './EditPersonaFormContext';

interface EditPersonaFormProviderProps {
  form: UseEditPersonaFormReturn;
  children: React.ReactNode;
}

/**
 * Custom form provider that wraps react-hook-form's FormProvider
 */
export function EditPersonaFormProvider({ form, children }: EditPersonaFormProviderProps) {
  return (
    <FormContext.Provider value={form}>
      <ReactHookFormProvider {...form}>{children}</ReactHookFormProvider>
    </FormContext.Provider>
  );
}
